<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

interface Props {
  class?: HTMLAttributes['class']
}

defineProps<Props>()
</script>

<template>
  <div :class="cn('flex flex-col gap-4 overflow-y-auto flex-1 px-3 py-4', $props.class)">
    <slot />
  </div>
</template>
